import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { mgaApiRef, MgaApiClient } from './api/MgaApi';
import { rootRouteRef } from './alphaRoutes';

const mgaApi = ApiBlueprint.make({
  name: 'mga',
  params: define =>
    define(
      createApiFactory({
        api: mgaApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new MgaApiClient(discoveryApi, fetchApi),
      }),
    ),
});

const mgaPage = PageBlueprint.make({
  params: {
    path: '/mga',
    noHeader: true,
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/ChatPage').then(m => <m.ChatPageAlpha />),
  },
});

export default createFrontendPlugin({
  pluginId: 'mga',
  extensions: [mgaApi, mgaPage],
});
